<template>
  <div v-show="visible">
    <base-map width="100%" height="500px"
              canDraw
              :geometry="geometry"
              @update:geometry="$emit('update:geometry', $event)"
              ref="map" />
    <input type="hidden" name="geometry" :value="geometry" />
  </div>
</template>
<script>

export default {
  emits: ['update:geometry'],
  props: {
    geometry: {
      type: String,
      required: true,
    },
    visible: {
      type: Boolean,
      default: true,
    },
  },
  watch: {
    async visible (isVisible) {
      if (!isVisible) return
      await this.$nextTick()
      this.$refs.map.redraw()
    },
  },
}
</script>
